var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"element",class:[
    _vm.staticOpen ? '' : 'overflow-hidden',
    _vm.transitioning ? 'transitioning' : '',
    _vm.loaded ? 'loaded' : '',
    _vm.transitions ? 'transition-height' : '',
  ],style:(_vm.staticOpen ? '' : `height: ${_vm.height}px;`),on:{"transitionstart":function($event){_vm.transitioning = true},"transitionend":function($event){_vm.transitioning = false}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }